

import SiteMenuOverlay from "./SiteMenuOverlay.vue";
import { mapState } from "vuex";


export default {
  name: "SiteMenu",

  components: {
    SiteMenuOverlay,
  },

  computed: {
    ...mapState({
      isOpen: (state) => state.app.isSiteMenuOpen,
    })
  },

  methods: {
    close() {
      this.$store.commit('app/setIsSiteMenuOpen', false)
    },

    open() {
      this.$store.commit('app/setIsSiteMenuOpen', true)
    },
  },
};
